import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { Fragment } from 'react';
import Sparkline from '../../../components/Sparklines';
import { showDifficulty, showIntent, showSerpFeatures } from '../../../helpers/commerce';

export const COLUMNS = (t, project_id, own_domain) => [
    {
        label: t('commerce.clusters_detail.own_urls.keyword'),
        key: 'keyword',
        data: 'keyword',
        sortType: 'string',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong className="wripe">
                    <a
                        href={`/commerce/${project_id}/keyword/${encodeURIComponent(
                            data,
                        )}?own_domain=${own_domain}`}
                        target="_blank"
                        rel="noreferrer"
                        className="d-flex justify-content-between align-items-center"
                    >
                        <span>{data}</span> <span style={{ fontSize: '30px' }}>→</span>
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('commerce.clusters_detail.own_urls.own_url'),
        key: 'own_url',
        data: 'own_url',
        sortType: 'string',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong className="wripe">{data ?? '-'}</strong>,
    },
    {
        label: t('commerce.clusters_detail.own_urls.search_volume'),
        key: 'search_volume',
        data: 'search_volume',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.own_urls.own_position'),
        key: 'own_position',
        data: 'own_position',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : !data ? '-' : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.clusters_detail.own_urls.cpc'),
        key: 'cpc',
        data: 'cpc',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => (csvDownload ? data : <strong>${data}</strong>),
    },
    {
        label: t('commerce.clusters_detail.own_urls.cpc_competition'),
        key: 'competition',
        data: 'competition',
        info: t('commerce.clusters_detail.own_urls.cpc_competition_info'),
        Component: Cell,
        renderCell: ({ data, csvDownload }) => (csvDownload ? data : <strong>{data}</strong>),
    },
    {
        label: t('commerce.clusters_detail.own_urls.serp_features'),
        key: 'keywords_serp_features',
        data: 'keywords_serp_features',
        Component: Cell,
        cellSize: 'minmax(180px, 1.5fr)',
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="d-flex align-center">{showSerpFeatures(data)}</div>
            ),
    },
    {
        label: t('commerce.clusters_detail.own_urls.keyword_difficulty'),
        key: 'keyword_difficulty_index',
        data: 'keyword_difficulty_index',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="d-flex align-items-center">
                    <strong>{data}</strong>
                    {showDifficulty(data)}
                </div>
            ),
    },
    {
        label: t('commerce.clusters_detail.own_urls.monthly_trends'),
        key: 'trends',
        data: 'trends',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <Sparkline
                    dataL={data?.split(',')?.map(Number)}
                    keyName="Trends"
                    dontShowLable={true}
                />
            ),
    },
    {
        label: t('commerce.clusters_detail.own_urls.intent'),
        key: 'intent',
        data: 'intent',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="d-flex align-center">
                    {showIntent(data)?.map((item, i) => (
                        <Fragment key={i}>{item}</Fragment>
                    ))}
                </div>
            ),
    },
    {
        label: t('commerce.clusters_detail.own_urls.number_of_results'),
        key: 'number_of_results',
        data: 'number_of_results',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
];
